import React from "react";
import { INotification } from "../../../Notification/Index";
import { OutputMappingView } from "./OutputMapping.view";

interface IOutputMappingProps {
  /**
   * Notification message items that needs that are currently available in redux state
   */
  notificationItems: INotification[];
}
/**
 * Rsponsible for Output mapping logic
 * @returns Output mapping logic
 */
export const OutputMapping: React.FC<IOutputMappingProps> = (props: IOutputMappingProps) => {
  return (<OutputMappingView notificationItems={props.notificationItems}/>);
};
